import { css } from "@emotion/css";
import PageContent from "../../../../components/molecule/pageContent";
import { RiArrowGoBackLine } from "@remixicon/react";
import { useState, useEffect } from "react";

const MemoriasDaAlmaOcultoVestigio = () => {

    const [answer, setAnswer] = useState(false);

    const pageCSS = css`
        .kt-page-content-primary {
            background-repeat: no-repeat;
            background-size: cover;
            box-sizing: border-box;
            padding: 10%;
            padding-top: calc(10% + 100px);
    
            h1 {
                background-color: #1b0a02;
                box-sizing: border-box;
                padding: 15px 0px 15px 1rem;
                font-weight: 400;
                letter-spacing: 1rem;
                color: #ffffff;
                width: fit-content;
                font-family: 'Fira Code', monospace;
                text-align: center;
                font-size: ${window.innerWidth > 500 ? "3.75rem" : "2.75rem"};
            }
    
            .brand {
                position: absolute;
                top: 10%;
                left: 10%;
                color: #ffffff;
                font-family: 'Fira Code', monospace;
                letter-spacing: 0.5rem;
                width: max-content;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                
                &::before {
                    content: 'ARQUIVO VIVO';
                    width: fit-content;
                    font-size: 1.75rem;
                }
                    
                &::after {
                    content: 'MEMÓRIAS DA ALMA';
                    width: fit-content;
                    font-size: .75rem;
                }
            }
    
            &#first {
                background-image: url('/img/bg_4.jpeg');
            }
        }
    
        .kt-page-content-secondary {
            text-align: center;
            font-family: 'Source Code Pro', Arial;
            font-weight: 500;
            font-size: 2rem;
            padding: 50px;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            text-transform: uppercase;
    
            &::before {
                content: '';
                position: absolute;
                z-index: -1;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                background-repeat: no-repeat;
                background-size: cover;
                background-image: url('/img/bg_1.jpeg');
                background-position: center;
            }
    
            p {
                margin: 0;
                line-height: 2.5rem;
                color: #ffffff;
            }
        }

        #second {
            background-image: url('/img/bg_17.jpeg');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            display: flex;
            justify-content: center;
            flex-direction: column;
            gap: 75px;
            padding: 75px;
            box-sizing: border-box;

            label {
                color: #ffffff;
                font-size: 2rem;
                font-family: Caveat, Arial;
                font-weight: 700;
                background-color: rgba(27, 10, 2, 0.8);
            }
        }

        #third {
            img {
                width: 100%;
                margin-bottom: -5px;
            }
        }

        #fourth {
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: url('/img/bg_23.jpeg');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            flex-direction: column;

            label {
                color: #ffffff;
                font-size: 1.75rem;
                text-align: center;
                width: 100%;
                max-width: 600px;
                margin-bottom: 50px;
                font-family: Caveat, Arial;
                font-weight: 700;
            }

            div {
                text-align: center;

                h2 {
                    color: #c39b54;
                    font-size: 4rem;
                    margin-bottom: 20px;
                    letter-spacing: 0.5rem;
                    -webkit-text-stroke: 3px black; 
                    paint-order: stroke fill; 
                }

                p {
                    color: #ffffff;
                    font-family: Caveat, Arial;
                    font-weight: 700;
                    font-size: 1.75rem;
                }
            }

            form {
                gap: 30px;
                display: flex;
                flex-wrap: wrap;
                max-width: 400px;
                justify-content: center;
                align-items: center;
                text-align: center;
                border: 1px solid #c39b54;
                background-color: rgba(27, 10, 2, 0.8);
                padding: 50px;
                box-sizing: border-box;
                border-radius: 10px;

                input {
                    flex: 1;
                    height: 50px;
                    border: none;
                    padding: 0 10px;
                    box-sizing: border-box;
                    font-size: 1.5rem;
                    background: none;
                    color: #ffffff;
                    border-bottom: 1px solid #ffffff;
                    transition: 0.5s;

                    &:focus {
                        outline: none;
                        border-bottom: 1px solid #c39b54;
                        transition: 0.5s;
                    }

                    &:hover {
                        transform: scale(1.02);
                        transition: 0.5s;
                    }
                }

                button {
                    flex: 1;
                    text-align: center;
                    background-color: #1b0a02;
                    padding: 15px;
                    color: #ffffff;
                    box-sizing: border-box;
                    height: 70px;
                    font-weight: 600;
                    border: 1px solid #c39b54;
                    border-radius: 10px;
                    font-size: 1.5rem;
                    cursor: pointer;
                    transition: 0.5s;

                    &:hover {
                        background-color: #c39b54;
                        color: #1b0a02;
                        transform: scale(1.05);
                        transition: 0.5s;
                    }
                }
            }
        }

        #return-to-lobby {
            position: fixed;
            bottom: 20px;
            left: 20px;
            font-size: 2rem;
            color: #ffffff;
            cursor: pointer;
            background-color: #1b0a02;
            padding: 10px;
            border-radius: 50%;
            z-index: 1000;
            border: 1px solid #c39b54;
            opacity: 1;
            transition: 0.5s;

            &:hover {
                background-color: #c39b54;
                color: #1b0a02;
                transform: scale(1.05);
                transition: 0.5s;
            }
        }
    `;

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = JSON.stringify(Object.fromEntries(formData.entries()));

        localStorage.setItem('memorias_da_alma_vestigio', data);

        e.target.reset();

        setAnswer(JSON.parse(data));
    }

    useEffect(() => {
        const storedData = localStorage.getItem('memorias_da_alma_vestigio');

        if (storedData) {
            setAnswer(JSON.parse(storedData));
        }
    }, []);

    return (<div className={pageCSS}>
        <PageContent id="first" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>
                CAIXA DE<br/>
                VESTÍGIOS
            </h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                Ao terminar este livro, talvez você perceba que algumas memórias não pertencem apenas às páginas.
                Elas pertencem à sua própria história.<br/><br/>

                Por isso, convido você a criar sua Caixa de<br/>
                Vestígios.<br/><br/>

                Escolha uma caixa. Não precisa ser bonita. Precisa<br/>
                apenas ser verdadeira.<br/><br/>

                Ao longo da vida, coloque nela objetos que façam<br/>
                sua alma recordar.<br/><br/>

                Uma flor encontrada em um dia especial.<br/>
                Uma carta que nunca foi enviada.<br/>
                Uma fotografia.<br/>
                Uma folha caída no caminho.<br/>
                Um ingresso.<br/>
                Uma pedra.<br/>
                Uma música escrita em um pedaço de papel.<br/>
                Um desenho.<br/>
                Uma frase.<br/><br/>

                Qualquer coisa que carregue um significado que o<br/>
                tempo não consiga apagar.<br/>

                Não colecione objetos.<br/>
                Colecione sentidos.<br/><br/>

                Um dia, quando abrir essa caixa novamente, talvez<br/>
                você descubra que ela nunca guardou apenas<br/>
                lembranças.<br/><br/>

                Ela guardou quem você foi.<br/>
                E, silenciosamente, quem você está se tornando.<br/>
                Porque a alma também deixa vestígios.<br/>
                E, às vezes, são eles que nos ajudam a encontrar o<br/>
                caminho de volta.
            </p>
        </PageContent>
        <PageContent id="second">
            <label>
                Se tudo o que você ama é impermanente... por que o amor continua sendo a experiência mais importante da existência?
            </label><label>
                Quem você reconheceria... mesmo na completa escuridão?
            </label><label>
                Você está vivendo... ou apenas atravessando o tempo?
            </label><label>
                Se hoje fosse sua última oportunidade de dizer "eu te amo", para quem seriam essas palavras?
            </label><label>
                O que significa, para você, voltar para casa?
            </label><label>
                Você acredita que algumas pessoas chegam para nos transformar ou para nos recordar?
            </label><label>
                Existe alguma pintura, música ou livro que mudou a forma como você vê a vida?
            </label><label>
                Qual criação sua continuará falando quando você não puder mais ?
            </label><label>
                Se a vida é impermanente, será que a arte é a forma que a alma encontrou para permanecer?
            </label><label>
                E se toda obra de arte fosse uma memória tentando voltar para casa?
            </label><label>
                O universo nos separou... ou nos ensinou a amar?
            </label><label>
                Somos apenas passageiros do tempo... ou guardiões de algo eterno?
            </label><label>
                Se sua vida fosse uma estação, você estaria  esperando, partindo ou chegando?
            </label><label>
                O que o livro revelou sobre você?
            </label><label>
                O amor verdadeiro nasce quando encontramos alguém... ou quando reconhecemos uma parte de nós no outro?
            </label>        
        </PageContent>
        <PageContent id="third">
            <img 
                src="/img/bg_22.png"
                alt="vestigio"
            />
        </PageContent>
        <PageContent id="fourth">
            <label>
                Deixe um vestigio: uma palavra, uma pergunta,<br/>
                uma memória, uma descoberta ... <br/>
                O que este livro deixou em você?
            </label>
            {answer ? <div>
                <h2>{answer.palavra}</h2>
                <p>
                    Obrigada {answer.nome.split(' ')[0]}, por deixar seu vestígio!<br/>
                    Ele foi guardado com carinho.<br/><br/>
                </p>
            </div>
            : <form onSubmit={handleSubmit}>
                <input name="nome" placeholder="Seu nome(Opcional)"/>
                <input name="palavra" required placeholder="Uma palavra"/>
                <button type="submit">ENVIAR</button>
            </form>}
        </PageContent>
        <a href="/memorias-da-alma/oculto/home/#lobby">
            <RiArrowGoBackLine id="return-to-lobby" />
        </a>
    </div>)
}

export default MemoriasDaAlmaOcultoVestigio;